import { Component, OnInit, ViewContainerRef, ViewChild } from '@angular/core';
import { CapacityModelService } from "./../services/CapacityModel-Service";
import { ResponseMsg } from "./../common/response-message";
import { ActivatedRoute, Router } from "@angular/router";
import { ValidateDataService } from "./../services/validate-data.service";
import { QuotaInputData } from "./../models/cm-model";
import { UserData } from '../shared/models/user.model';
import {SohoModalDialogService, SohoBusyIndicatorDirective,
  SohoMessageRef, SohoNotificationService,SohoDatePickerComponent} from "ids-enterprise-ng";
import { DatePipe } from '@angular/common';          


@Component({
  selector: 'app-download-template',
  template: 
  `<div><p> &nbsp;&nbsp; Click on below links to download templates</p> <br>
  <div style="font-size: 1.6rem; padding: 10px;padding-bottom:0px"> <a href="assets/Templates/AllPlansAutomated_2026.xlsx" download="AllPlansAutomated.xlsx">All Plans Automated </a></div>
  </div>
  `,
  providers: [DatePipe]
})
export class DownloadTemplateComponent implements OnInit {
    constructor(private capacityModelService : CapacityModelService,public router: Router) {
      }

  ngOnInit(): void {
  }
}